import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {CSSProperties} from 'react'
import {CampusDashboardCard} from './CampusDashboardCard'
import {connect} from 'react-redux'
import {Link} from 'react-router'
import {browserHistory} from 'react-router';
import {ProofPopup} from './ProofPopup'
import * as Request from '../tgccRequest'

declare var ProofBase: string;

const listStyle: CSSProperties = {
    position: 'relative',
    height: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    display:'flex',
    flexWrap:'wrap',
    justifyContent:'center'
}

const orderStyle: CSSProperties = {
    alignSelf: 'center',
    display: 'flex',
    flexDirection: 'column',
    margin: '4px 6px',
    padding: '5px',
    background: Tgcc.Styles.paleWhite,
    cursor:'pointer',
    overflow:'auto',
    width:'360px',
    height: '565px',
    textTransform:'none'
}

const imgStyle: CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    height: 'auto',
    width: '350px',
}

const orderTextStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
}
const idTextStyle    : CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'BarlowBlack',
    fontSize: '20px',
    letterSpacing: '3px',
    lineHeight: '18px',
    color:'#616060'
}
const imgDiv: CSSProperties = {
    width:'25%'

}
let subTextStyle = Object.assign({}, idTextStyle, {fontSize: '16px', lineHeight: '15px', letterSpacing: '1px',fontFamily:'BarlowLight',flexDirection:'row'});
let textStyle = Object.assign({},idTextStyle, {fontFamily:'BarlowMedium',fontSize:'16px'})


class Props extends Tgcc.BaseProps {
    loginData: Tgcc.LoginData;
}

class _MajorAccountsActiveOrders extends React.Component<Props, any>{
    state = {
        orders: null,
        error: null,
        viewPopup: null,
        isWaiting: true
    }

    componentWillMount(){
        this.loadActive(this.props);
    }

    componentWillReceiveProps(props: Props){
        this.loadActive(props)
    }

    loadActive = (props: Props) => {
        if(props.loginData){
            if(!this.state.orders){
                Request.getActiveProofs(props.loginData, this.loaded, this.error);
            } else if( props.loginData.impersonate) {
                this.setState({orders: null, isWaiting: true});
                Request.getActiveProofs(props.loginData, this.loaded, this.error);
            } else if (this.state.orders.length) {
                var ord1: Tgcc.Proof = this.state.orders[0]
                if(ord1.userEmail != props.loginData.username){
                    this.setState({orders: null, isWaiting: true});
                    Request.getActiveProofs(props.loginData, this.loaded, this.error);
                }
            }
        }
    }

    loaded = (proofs: Tgcc.Proof[]) => {
        this.setState({orders: proofs, isWaiting: false });
    }

    error = (err) => {
        this.setState({orders: [], error: err, isWaiting: false});
    }

    handleMissingProofImage = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingProofImageSrc;
    }
    getStatusColor(proofStatus:string){
        if(proofStatus === 'APPROVED' || proofStatus === 'ACTIVE LINK'){
            return Object.assign({},{},{color:'green'});
        }
        else if (proofStatus === 'HOLD'){
            return Object.assign({},{},{color:'orange'});
        }
        else {
            return Object.assign({},{},{color:'#616060'});
        }

    }
    


    getOrderItem = (proof: Tgcc.Proof) => {
        var event = proof.eventName ? <div style={subTextStyle}>{proof.eventName}</div> : null;
        return (
            <div key={proof.proofId+proof.statusDate} onClick={ () => this.reviseProof(proof) } >
                <div style={orderStyle} className="hoverBorder">
                    <div style={imgDiv}>
                        <img style={imgStyle} src={Tgcc.getProofPath(proof.proofId)} onError={this.handleMissingProofImage} />
                    </div>
                    <div style={orderTextStyle} className="textActive">
                        {event}
                        <div style={subTextStyle}><span style={textStyle}>Updated:</span> {proof.statusDate}</div>
                        <div style={subTextStyle}><span style={textStyle}>Status:</span> <span style={this.getStatusColor(proof.status)}>{proof.status}</span></div>
                        <div style={subTextStyle} className="csrActive"><span style={textStyle}>CSR:</span>{proof.csrName} - {proof.csrEmail}</div>

                    </div>
                </div>
            </div>
        )
    }

    getOrders = () => {
        var elements = new Array();
        if(this.state.orders){
            for(var i in this.state.orders){
                var p: Tgcc.Proof = this.state.orders[i];
                elements.push(this.getOrderItem(p));
            }
        }
        return elements;
    }

    reviseProof = (proof: Tgcc.Proof) => {
        browserHistory.push(Tgcc.Routes.ProofView(proof.proofId))
    }
    render() {
        var waiting = this.state.isWaiting ? Tgcc.workingGif : null;
        var orders = this.getOrders(); 

        return (
            <CampusDashboardCard title="active orders" >
                <div style={listStyle} className="campActOrders">
                    {waiting}
                    {orders}
                </div>
            </CampusDashboardCard>
        )
    }
}


const mapStateToProps = (state: Tgcc.GlobalState) => {
    var lData: Tgcc.LoginData = state.LoginData ? state.LoginData : null;
    return { 
        loginData: lData
    };
};
export var MajorAccountsActiveOrders = connect(mapStateToProps)(_MajorAccountsActiveOrders);
